import { Commercial, EditType, TCommercialId } from '@talon/web/lib/api';
import { Box, Button, Select, Text } from 'grommet';
import { observer } from 'mobx-react-lite';
import { useState } from 'react';
import { ModalCard } from '../ModalCard';

export interface ICreateEditModalProps {
  commercial: Commercial;
  addEdit: (commercialId: TCommercialId, editType: EditType) => void;
  setShowModal: (isVisible: boolean) => void;
}

export const CreateEditModal = observer(({ commercial, addEdit, setShowModal }: ICreateEditModalProps) => {
  const [type, setType] = useState<EditType>();

  return (
    <ModalCard onClose={() => setShowModal(false)} title="Add Edit">
      <Box gap="small">
        <Box gap="small" pad="small" justify="center" fill="horizontal">
          <Box fill="horizontal">
            <Text>Edit Type:</Text>
          </Box>
          <Box fill="horizontal">
            <Select
              value={type}
              options={Object.values(EditType)}
              onChange={({ value }) => setType(value as EditType)}
              placeholder="Select Edit Type"
            />
          </Box>
        </Box>

        <Box direction="row" justify="end" align="center" margin={{ vertical: 'small' }}>
          <Button
            primary
            label="Add Edit"
            disabled={!type}
            onClick={() => (type ? addEdit(commercial.id, type) : {})}
          />
        </Box>
      </Box>
    </ModalCard>
  );
});
